import React, {useState, useEffect} from "react";
import AddPronunciationComponent from "./AddPronunciationComponent";
import _ from 'lodash'
import {storage} from "../../../firebase";
import firebase from "firebase";
import PronunciationCard from "../../../StudentPages/Pronunciation/PronunciationCard";
import {Button, Icon} from "semantic-ui-react";
import {CheckEmptyField} from "../../../helpers/CheckEmptyFields/CheckEmptyField";
import {DownloadJSONFile} from "../../../helpers/DownloadJSONFile";

function StepTwoAddPronunciation(
    {
        soundsList,
        handleBackToSounds,
        classLevel,
        handleClassLevel,
        editSoundNames,
        editAssignment,
        assignmentName,
        setEditAssignmentLoading,
        setEditAssignmentProgress,
        actionChoice,
        databaseChoice
    }
) {

    const [nameButtons, setNameButtons] = useState([]);
    const [fileNames, setFileNames] = useState([]);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [progress, setProgress] = useState(0);
    const [progressText, setProgressText] = useState('');
    const [sounds, setSounds] = useState([]);
    const [buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        async function fetchData() {
            let tmpLength = soundsList.length;
            for (let i = 0; i < tmpLength; i++) {
                setNameButtons(prevState => _.flatten([prevState, ""]))
            }
            let tmpFileNames = [];
            firebase.storage().ref().child('assignments/Samoan101/pronunciationAssignments').listAll()
                .then((data) => {
                    data.items.forEach((folderRef) => {

                        tmpFileNames.push(folderRef.location.path_.split('/')[3])
                    })
                }).catch(e => console.log(e));

            let retrievedSoundsURLArray = [];
            const allSounds = firebase.storage().ref().child('sounds');
            for (let i = 0; i < soundsList.length; i++) {
                const retrievedSound = allSounds.child(soundsList[i].name);
                await retrievedSound.getDownloadURL().then((url) => {
                    retrievedSoundsURLArray.push(url);
                    setProgress(prevState => prevState + Math.round(100 / soundsList.length));
                    setProgressText('Loading sounds');
                })
            }
            let tmpSounds = [];
            for (let i = 0; i < retrievedSoundsURLArray.length; i++) {
                tmpSounds.push(new Audio(retrievedSoundsURLArray[i]))
            }
            setSounds(tmpSounds);
            setButtons(_.times(soundsList.length, (i) => (
                <Button style={{marginLeft: 5}} color='blue' icon size='mini' onClick={()=>tmpSounds[i].play()}><Icon name='sound'/></Button>
            )));

            setFileNames(tmpFileNames)
        }

        fetchData().then(()=>setLoading(false)).catch(e=>console.log(e))
        if(editAssignment){
            setNameButtons([...editSoundNames])
        }
    }, []);

    const handleSubmit = () => {
        let assigmentObj = [];
        setError('')
        for (let i = 0; i < nameButtons.length; i++) {
            let itemObj = {name: nameButtons[i], file: soundsList[i].name};
            assigmentObj.push(itemObj);
        }
        const tmpError = CheckEmptyField(assigmentObj);
        if(tmpError) {
            setError(tmpError);

        } else {
            if(editAssignment){
                DownloadJSONFile(assigmentObj, assignmentName).then(r => console.log('ready'))
                const JSONobj = JSON.stringify(assigmentObj);
                const blobObj = new Blob([JSONobj], {type: "application/json"});

                const uploadTask = storage.ref(`assignments/Samoan101/pronunciationAssignments/` + assignmentName).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan101/pronunciationAssignments")
                            .child(assignmentName)
                            .getDownloadURL()
                            .then(() => {
                                    setSuccess(true)
                                }
                            )
                            .catch(e => console.log(e));
                    }
                )
            } else {
                DownloadJSONFile(assigmentObj, fileNames).then(r => console.log('ready'))
                const JSONobj = JSON.stringify(assigmentObj);
                const blobObj = new Blob([JSONobj], {type: "application/json"});
                const uploadTask = storage.ref(`assignments/Samoan101/pronunciationAssignments/assignment${fileNames.length + 1}.json`).put(blobObj);
                uploadTask.on(
                    "state_changed",
                    () => {
                    },
                    error => {
                        console.log(error)
                    },
                    () => {
                        storage
                            .ref("assignments/Samoan101/pronunciationAssignments")
                            .child(`assignment${fileNames.length + 1}.json`)
                            .getDownloadURL()
                            .then(url => {
                                    setSuccess(true)
                                }
                            )
                            .catch(e => console.log(e));
                    }
                )
            }

        }

    };

    const handleChange = (event, {value}) => {
        let tmpNameButtons = nameButtons;
        tmpNameButtons[event.target.id] = value;
        setNameButtons([...tmpNameButtons]);
        setError('')
    };


    return (
        <>
            <AddPronunciationComponent
                soundsList={soundsList}
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                success={success}
                nameButtons={nameButtons}
                fileNmaes={fileNames}
                error={error}
                buttons={buttons}
                progress={progress}
                progressText={progressText}
                loading={loading}
                handleBackToSounds={handleBackToSounds}
                classLevel={classLevel}
                handleClassLevel={handleClassLevel}
            />
        </>
    )
}

export default StepTwoAddPronunciation
